import InputMask from './InputMask';

export default InputMask;



// WEBPACK FOOTER //
// ./src/Services/InputMask/index.tsx